// extracted by mini-css-extract-plugin
export var container = "Card-module--container--PTy3L";